import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethods = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3189_4973)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.75 12H8.25C7.00927 12 6 13.0093 6 14.25V15H24V14.25C24 13.0093 22.9907 12 21.75 12Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 21.75C6 22.9907 7.00927 24 8.25 24H21.75C22.9907 24 24 22.9907 24 21.75V16.5H6V21.75ZM20.25 20.25C20.6642 20.25 21 20.5858 21 21C21 21.4142 20.6642 21.75 20.25 21.75C19.8358 21.75 19.5 21.4142 19.5 21C19.5 20.5858 19.8358 20.25 20.25 20.25ZM16.5 20.25H18C18.4142 20.25 18.75 20.5858 18.75 21C18.75 21.4142 18.4142 21.75 18 21.75H16.5C16.0858 21.75 15.75 21.4142 15.75 21C15.75 20.5858 16.0858 20.25 16.5 20.25Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.875 10.5V2.25C13.875 1.01249 12.8625 0 11.625 0H2.25C1.01253 0 0 1.01249 0 2.25V18.75C0 19.9875 1.01253 21 2.25 21H4.5V14.25C4.5 12.18 6.17999 10.5 8.25 10.5H13.875ZM5.63488 3.75C5.2207 3.75 4.88488 3.41419 4.88488 3C4.88488 2.58581 5.2207 2.25 5.63488 2.25H8.24011C8.65429 2.25 8.99011 2.58581 8.99011 3C8.99011 3.41419 8.65429 3.75 8.24011 3.75H5.63488Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7082 6.74994C19.263 6.75003 19.6429 7.39113 19.3572 7.87416C19.0808 8.34126 18.3323 8.34172 18.0582 7.87201C17.8491 7.51459 17.3895 7.39337 17.0324 7.60211C16.6746 7.81085 16.5538 8.27009 16.7625 8.62787C17.0387 9.10157 17.4658 9.4318 17.9582 9.6063V9.74995C17.9582 10.7053 19.4582 10.7247 19.4582 9.74995V9.60626C19.9504 9.43175 20.3771 9.10184 20.6528 8.62898C21.5138 7.15199 20.4042 5.24999 18.7083 5.24994C18.1536 5.2499 17.773 4.60838 18.059 4.12549C18.3355 3.65861 19.0837 3.65816 19.3579 4.12787C19.5666 4.48529 20.0258 4.60614 20.3836 4.39776C20.7414 4.18902 20.8623 3.72979 20.6535 3.372C20.3773 2.8984 19.9503 2.56821 19.4582 2.39367C19.4582 2.39367 19.4582 2.25071 19.4582 2.24993C19.4582 1.29147 17.9582 1.27664 17.9582 2.24993V2.39354C17.4659 2.56799 17.039 2.89795 16.7633 3.37091C15.9029 4.84674 17.0109 6.74985 18.7082 6.74994Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3189_4973",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgPaymentMethods;
